import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { GenericService } from '../../services/generic.service';
import { ObjectTransitService } from '../../services/object-transit.service';

@Component({
  selector: 'app-object-transit-controller',
  templateUrl: './object-transit-controller.component.html',
  styleUrls: ['./object-transit-controller.component.css']
})
export class ObjectTransitControllerComponent implements OnInit {
  addMode: 'single' | 'bulk' = 'single';
  allTransitsList: any[] = [];

  isLoading: boolean = false;
  first: number = 0;
  pageNumber: number = 0;
  tableSize: number = 10;
  totalRecords: number = 0;
  recordsPerPage: any = 10

  addObjectsTransitForm!: FormGroup;
  editObjectsTransitForm!: FormGroup;
  editBulkTransitForm!: FormGroup;

  objectInfoList: any[] = [];
  locationList: any[] = [];
  locationFilterList: any[] = [];
  singleObjectsTransitData: any;

  recordId: string = "";
  recordName: string = "";
  id: string = "";
  formSubmit: boolean = false;

  assetDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'givenName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  userCred: any;
  userType: any;
  userLocations: any[] = [];
  cid: number = 0;
  actionControls: any = {};
  searchFilter: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    private titleService: Title,
    private genericService: GenericService,
    private objectTransitService: ObjectTransitService
  ) {

  }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid')) || 0;
    let userCreds = sessionStorage.getItem('userCreds');
    if (userCreds) {
      this.userCred = JSON.parse(userCreds);
      this.userType = this.userCred?.userType;
    }

    this.getPrivileges();
    this.initForms();

    this.getAllLocation();

    // this.getAllObjectInfoByLocationsAndCid();
    this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
  }

  getPrivileges() {
    let href: any = window.location.href;
    let messages = href.split('/');
    let action: any = this.genericService.checkActionControls(messages[messages.length - 1]);
    this.actionControls = action || {};
  }

  getAllLocation() {
    this.genericService.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response || [];
        this.locationList = this.locationList.filter((location: any) => location.stockPoint === true);
        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  // getAllObjectInfoByLocationsAndCid() {
  //   const body: any = {
  //     "location": this.userLocations || [],
  //     "cid": this.cid,
  //     "pageNo": 0,
  //     "recordsPerPage": 0,
  //     "version": 0,
  //     "isActive": true,
  //     "description": "",
  //   };
  //   this.genericService.getAllObjectInfoByLocationsAndCid(body).subscribe(
  //     (res: any) => {
  //       this.objectInfoList = res.response || [];
  //     },
  //     (err: any) => {
  //       console.log(err);
  //     }
  //   );
  // }

  isBulk(transit: any): boolean {
    return transit && transit.objectTransitList && transit.objectTransitList.length > 0;
  }

  setAddMode(mode: 'single' | 'bulk') {
    this.addMode = mode;
    this.addObjectsTransitForm.reset();

    if (mode === 'single') {
      this.addObjectsTransitForm.get('objectInfoId')?.setValidators([Validators.required]);
      this.addObjectsTransitForm.get('objectInfoIds')?.clearValidators();
    } else {
      this.addObjectsTransitForm.get('objectInfoIds')?.setValidators([Validators.required]);
      this.addObjectsTransitForm.get('objectInfoId')?.clearValidators();
    }
    this.addObjectsTransitForm.get('objectInfoId')?.updateValueAndValidity();
    this.addObjectsTransitForm.get('objectInfoIds')?.updateValueAndValidity();
  }

  initForms() {
    this.addObjectsTransitForm = this.formBuilder.group({
      objectInfoId: [''],
      objectInfoIds: [[]],
      fromLocation: [null, Validators.required],
      toLocation: [null, Validators.required],
      description: ['']
    });

    this.addObjectsTransitForm.get('fromLocation')?.valueChanges.subscribe((value: any) => {
      if (value && value === this.addObjectsTransitForm.get('toLocation')?.value) {
        this.addObjectsTransitForm.get('toLocation')?.setValue(null);
      }
      if (value) {
        this.getAllByLocationAndNotinTransitAndCid(value);
      }
    });

    this.editObjectsTransitForm = this.formBuilder.group({
      transitId: [''],
      status: ['', Validators.required],
      objectName: [''],
      fromLocation: [null, Validators.required],
      toLocation: [null, Validators.required],
      description: [''],
      objectInfoId: [''],
      fromCountry: [''],
      fromProvinceOrState: [''],
      fromDistrict: [''],
      fromZone: [''],
      fromPostalCode: [''],
      fromCity: [''],
      toCountry: [''],
      toProvinceOrState: [''],
      toDistrict: [''],
      toZone: [''],
      toPostalCode: [''],
      toCity: ['']
    });

    this.editObjectsTransitForm.get('fromLocation')?.valueChanges.subscribe((value: any) => {
      if (value && value === this.editObjectsTransitForm.get('toLocation')?.value) {
        this.editObjectsTransitForm.get('toLocation')?.setValue(null);
      }
      if (value) {
        this.getAllByLocationAndNotinTransitAndCid(value);
      }
    });

    this.editBulkTransitForm = this.formBuilder.group({
      description: [''],
      objectTransitList: this.formBuilder.array([])
    });
  }

  get editTransitArray(): FormArray {
    return this.editBulkTransitForm.get('objectTransitList') as FormArray;
  }

  createEditTransitGroup(): FormGroup {
    return this.formBuilder.group({
      transitId: [''],
      status: ['', Validators.required],
      objectName: [''],
      fromLocation: [null, Validators.required],
      toLocation: [null, Validators.required],
      description: [''],
      objectInfoId: [''],
      fromCountry: [''],
      fromProvinceOrState: [''],
      fromDistrict: [''],
      fromZone: [''],
      fromPostalCode: [''],
      fromCity: [''],
      toCountry: [''],
      toProvinceOrState: [''],
      toDistrict: [''],
      toZone: [''],
      toPostalCode: [''],
      toCity: ['']
    });
  }



  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.first = event.first;
    this.tableSize = event.rows;
    this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);

  }

  refreshAll() {
    this.pageNumber = 0;
    this.first = 0;
    this.searchFilter = "";
    this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
  }

  getAllObjectsTransitWithPagination(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true;
    this.objectTransitService.getAllObjectsTransitWithPagination(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        this.allTransitsList = response.response.objectTransitList || [];
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false;
      },
      (error: any) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  addObjectTransit() {
    if (this.formSubmit) return;

    if (!this.addObjectsTransitForm.valid) {
      this.toastr.error("Please fill required fields");
      return;
    }

    let val = this.addObjectsTransitForm.value;
    if (val.fromLocation === val.toLocation) {
      this.toastr.error("From and To locations cannot be the same");
      return;
    }

    let fromLocation = this.locationList.find((item: any) => item.zone == val.fromLocation);
    let toLocation = this.locationList.find((item: any) => item.zone == val.toLocation);

    // If single item selected -> Single Transit API
    if (this.addMode === 'single') {
      this.formSubmit = true;
      let objectInfo = this.objectInfoList.find((item: any) => item.objectInfoId == val.objectInfoId);

      let body = {
        "version": 0,
        "isActive": true,
        "description": val.description,
        "objectInfoId": objectInfo?.objectInfoId,
        "objectName": objectInfo?.givenName,
        "status": "Requested",
        "fromCountry": fromLocation?.country,
        "fromProvinceOrState": fromLocation?.provinceOrState,
        "fromDistrict": fromLocation?.district,
        "fromZone": fromLocation?.zone,
        "fromPostalCode": fromLocation?.postalCode,
        "fromCity": fromLocation?.city,
        "fromLocation": fromLocation?.zone,
        "toCountry": toLocation?.country,
        "toProvinceOrState": toLocation?.provinceOrState,
        "toDistrict": toLocation?.district,
        "toZone": toLocation?.zone,
        "toPostalCode": toLocation?.postalCode,
        "toCity": toLocation?.city,
        "toLocation": toLocation?.zone,
        "cid": this.cid,
        "requestDetails": {
          "version": 0, "isActive": true, "description": "",
          "userId": this.userCred?.userId, "userName": this.userCred?.userName,
          "userMobileNo": this.userCred?.userMobileNo, "userEmail": this.userCred?.userEmail, "cid": this.cid
        },
        "receivedDetails": {
          "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": 0
        },
        "fromArea": [{ "lat": "", "lng": "" }],
        "toArea": [{ "lat": "", "lng": "" }],
        "fromLat": 0, "fromLng": 0, "toLat": 0, "toLng": 0
      };

      this.objectTransitService.addObjectsTransit(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.closePopUp();
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          document.getElementById("closeAddModalButton")?.click();
          this.formSubmit = false;
        },
        (error: any) => {
          this.toastr.error(error.error?.errors?.[0]?.description || "Error adding transit");
          this.formSubmit = false;
        }
      );
    } else {
      let selectedAssets = val.objectInfoIds || [];
      if (selectedAssets.length === 0) {
        this.toastr.error("Please select at least one asset");
        return;
      }
      this.formSubmit = true;
      // Bulk Transit API
      let finalTransits = selectedAssets.map((item: any) => {
        return {
          "version": 0, "isActive": true, "description": val.description,
          "objectInfoId": item.objectInfoId, "objectName": item.givenName, "status": "Requested",
          "fromCountry": fromLocation?.country, "fromProvinceOrState": fromLocation?.provinceOrState,
          "fromDistrict": fromLocation?.district, "fromZone": fromLocation?.zone, "fromPostalCode": fromLocation?.postalCode,
          "fromCity": fromLocation?.city, "fromLocation": fromLocation?.zone,
          "toCountry": toLocation?.country, "toProvinceOrState": toLocation?.provinceOrState,
          "toDistrict": toLocation?.district, "toZone": toLocation?.zone, "toPostalCode": toLocation?.postalCode,
          "toCity": toLocation?.city, "toLocation": toLocation?.zone,
          "cid": this.cid,
          "requestDetails": {
            "version": 0, "isActive": true, "description": "", "userId": this.userCred.userId, "userName": this.userCred.userName, "userMobileNo": this.userCred.userMobileNo, "userEmail": this.userCred.userEmail, "cid": this.cid
          },
          "receivedDetails": {
            "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": 0
          },
          "fromArea": [{ "lat": "", "lng": "" }], "toArea": [{ "lat": "", "lng": "" }],
          "fromLat": 0, "fromLng": 0, "toLat": 0, "toLng": 0
        }
      });

      let body = {
        "objectTransit": {
          "objectInfoId": "", "objectName": "", "status": "Requested",
          "fromCountry": fromLocation?.country, "fromProvinceOrState": fromLocation?.provinceOrState,
          "fromDistrict": fromLocation?.district, "fromZone": fromLocation?.zone, "fromPostalCode": fromLocation?.postalCode,
          "fromCity": fromLocation?.city, "fromLocation": fromLocation?.zone,
          "toCountry": toLocation?.country, "toProvinceOrState": toLocation?.provinceOrState,
          "toDistrict": toLocation?.district, "toZone": toLocation?.zone, "toPostalCode": toLocation?.postalCode,
          "toCity": toLocation?.city, "toLocation": toLocation?.zone,
          "requestDetails": {
            "version": 0, "isActive": true, "description": "", "userId": this.userCred.userId, "userName": this.userCred.userName, "userMobileNo": this.userCred.userMobileNo, "userEmail": this.userCred.userEmail, "cid": this.cid
          },
          "receivedDetails": {
            "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": 0
          },
          "fromArea": [{ "lat": "", "lng": "" }], "toArea": [{ "lat": "", "lng": "" }],
          "fromLat": 0, "fromLng": 0, "toLat": 0, "toLng": 0,
          "description": val.description, "cid": this.cid,
          "objectTransitList": finalTransits
        }
      };

      this.objectTransitService.insertBulkObjectTransit(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.closePopUp();
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          document.getElementById("closeAddModalButton")?.click();
          this.formSubmit = false;
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    }
  }

  getObjectsTransitByObjectTransitId(objectTransitId: any, type: 'single' | 'bulk') {
    this.objectTransitService.getObjectsTransitByObjectTransitId(objectTransitId).subscribe(
      (response: any) => {
        this.singleObjectsTransitData = response.response || [];

        if (type === 'single') {
          this.editObjectsTransitForm.patchValue(this.singleObjectsTransitData);
        } else if (type === 'bulk') {
          this.editTransitArray.clear();
          this.editBulkTransitForm.patchValue({ description: this.singleObjectsTransitData.description });
          let group = this.createEditTransitGroup();
          group.patchValue(this.singleObjectsTransitData);
          this.editTransitArray.push(group);
        }
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }

  updateObjectsTransit() {
    if (this.formSubmit) return;
    if (!this.editObjectsTransitForm.valid) {
      this.toastr.error("Please fill required fields");
      return;
    }

    let val = this.editObjectsTransitForm.value;
    if (val.fromLocation === val.toLocation && val.fromLocation) {
      this.toastr.error("From and To locations cannot be the same");
      return;
    }

    let fromLocation = this.locationList.find((item: any) => item.zone == val.fromLocation);
    let toLocation = this.locationList.find((item: any) => item.zone == val.toLocation);
    let objectInfo = this.objectInfoList.find((item: any) => item.objectInfoId == val.objectInfoId);

    this.editObjectsTransitForm.patchValue({
      objectName: objectInfo ? objectInfo.givenName : val.objectName,
      fromCountry: fromLocation ? fromLocation.country : val.fromCountry,
      fromProvinceOrState: fromLocation ? fromLocation.provinceOrState : val.fromProvinceOrState,
      fromDistrict: fromLocation ? fromLocation.district : val.fromDistrict,
      fromZone: fromLocation ? fromLocation.zone : val.fromZone,
      fromPostalCode: fromLocation ? fromLocation.postalCode : val.fromPostalCode,
      fromCity: fromLocation ? fromLocation.city : val.fromCity,
      toCountry: toLocation ? toLocation.country : val.toCountry,
      toProvinceOrState: toLocation ? toLocation.provinceOrState : val.toProvinceOrState,
      toDistrict: toLocation ? toLocation.district : val.toDistrict,
      toZone: toLocation ? toLocation.zone : val.toZone,
      toPostalCode: toLocation ? toLocation.postalCode : val.toPostalCode,
      toCity: toLocation ? toLocation.city : val.toCity,
    });

    this.formSubmit = true;
    val = this.editObjectsTransitForm.value;

    let body = {
      "version": this.singleObjectsTransitData.version || 0,
      "isActive": true,
      "description": val.description,
      "objectTransit": {
        ...val,
        "id": this.singleObjectsTransitData.id,
        "cid": this.cid,
        "version": this.singleObjectsTransitData.version || 0,
        "requestDetails": this.singleObjectsTransitData.requestDetails,
        "receivedDetails": this.singleObjectsTransitData.receivedDetails,
        "fromArea": [{ "lat": "", "lng": "" }],
        "toArea": [{ "lat": "", "lng": "" }],
        "isActive": true
      },
      "cid": this.cid
    };

    this.objectTransitService.updateObjectTransit(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.closePopUp();
        this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
        document.getElementById("closeEditSingleModalButton")?.click();
        this.formSubmit = false;
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }

  updateBulkObjectsTransit() {
    if (this.formSubmit) return;
    let val = this.editTransitArray.controls[0].value;

    if (val.fromLocation === val.toLocation && val.fromLocation) {
      this.toastr.error("From and To locations cannot be the same");
      return;
    }

    let group = this.editTransitArray.controls[0] as FormGroup;
    let fromLocation = this.locationList.find((item: any) => item.zone == val.fromLocation);
    let toLocation = this.locationList.find((item: any) => item.zone == val.toLocation);
    let objectInfo = this.objectInfoList.find((item: any) => item.objectInfoId == val.objectInfoId);

    group.patchValue({
      objectName: objectInfo ? objectInfo.givenName : val.objectName,
      fromCountry: fromLocation ? fromLocation.country : val.fromCountry,
      fromProvinceOrState: fromLocation ? fromLocation.provinceOrState : val.fromProvinceOrState,
      fromDistrict: fromLocation ? fromLocation.district : val.fromDistrict,
      fromZone: fromLocation ? fromLocation.zone : val.fromZone,
      fromPostalCode: fromLocation ? fromLocation.postalCode : val.fromPostalCode,
      fromCity: fromLocation ? fromLocation.city : val.fromCity,
      toCountry: toLocation ? toLocation.country : val.toCountry,
      toProvinceOrState: toLocation ? toLocation.provinceOrState : val.toProvinceOrState,
      toDistrict: toLocation ? toLocation.district : val.toDistrict,
      toZone: toLocation ? toLocation.zone : val.toZone,
      toPostalCode: toLocation ? toLocation.postalCode : val.toPostalCode,
      toCity: toLocation ? toLocation.city : val.toCity,
    });

    this.formSubmit = true;
    val = group.value;

    let finalTransits = [{
      ...val,
      "id": this.singleObjectsTransitData.id,
      "cid": this.cid,
      "version": this.singleObjectsTransitData.version || 0,
      "requestDetails": this.singleObjectsTransitData.requestDetails,
      "receivedDetails": {
        "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": 0
      },
      "fromArea": [{ "lat": "", "lng": "" }], "toArea": [{ "lat": "", "lng": "" }],
      "isActive": true
    }];

    let bulkTransits = finalTransits;
    if (this.singleObjectsTransitData?.objectTransitList && this.singleObjectsTransitData.objectTransitList.length > 0) {
      bulkTransits = this.singleObjectsTransitData.objectTransitList;
    }

    let body: any = this.getBulkUpdateBody(bulkTransits, this.singleObjectsTransitData?.status || "Requested");
    body.description = this.editBulkTransitForm.value.description || "";
    body.objectTransit.description = this.editBulkTransitForm.value.description || "";

    this.objectTransitService.updateBulkObjectTransitUponApproval(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.closePopUp();
        this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
        document.getElementById("closeEditBulkModalButton")?.click();
        this.formSubmit = false;
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }

  // --- Approvals logic ---

  statusUpdate(type: 'single' | 'bulk', status: any) {
    if (type === 'single') {
      let body: any = {
        "version": 0, "isActive": true, "description": this.singleObjectsTransitData?.description,
        "id": this.singleObjectsTransitData?.id, "transitId": this.singleObjectsTransitData?.transitId,
        "objectInfoId": this.singleObjectsTransitData?.objectInfoId, "objectName": this.singleObjectsTransitData?.objectName,
        "requestDetails": this.singleObjectsTransitData?.requestDetails, "receivedDetails": this.singleObjectsTransitData?.receivedDetails,
        "status": status, "fromCountry": this.singleObjectsTransitData?.fromCountry,
        "fromProvinceOrState": this.singleObjectsTransitData?.fromProvinceOrState, "fromDistrict": this.singleObjectsTransitData?.fromDistrict,
        "fromZone": this.singleObjectsTransitData?.fromZone, "fromPostalCode": this.singleObjectsTransitData?.fromPostalCode,
        "fromCity": this.singleObjectsTransitData?.fromCity, "fromLocation": this.singleObjectsTransitData?.fromLocation,
        "fromArea": this.singleObjectsTransitData?.fromArea, "toCountry": this.singleObjectsTransitData?.toCountry,
        "toArea": this.singleObjectsTransitData?.toArea, "toProvinceOrState": this.singleObjectsTransitData?.toProvinceOrState,
        "toDistrict": this.singleObjectsTransitData?.toDistrict, "toZone": this.singleObjectsTransitData?.toZone,
        "toPostalCode": this.singleObjectsTransitData?.toPostalCode, "toCity": this.singleObjectsTransitData?.toCity,
        "toLocation": this.singleObjectsTransitData?.toLocation, "cid": this.singleObjectsTransitData?.cid
      };
      this.objectTransitService.updateObjectTransitUponApproval(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          this.getObjectsTransitByObjectTransitId(this.singleObjectsTransitData?.transitId, 'single');
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    } else {
      let finalTransits: any[] = [];
      if (this.singleObjectsTransitData?.objectTransitList && this.singleObjectsTransitData.objectTransitList.length > 0) {
        const selectedItems = this.singleObjectsTransitData.objectTransitList.filter((item: any) => item.selected);
        if (selectedItems.length === 0) {
          this.toastr.error("Please select at least one item");
          return;
        }
        finalTransits = this.singleObjectsTransitData.objectTransitList.filter((item: any) => !item.selected);
      } else {
        finalTransits = [this.singleObjectsTransitData || {}];
      }
      let body: any = this.getBulkUpdateBody(finalTransits, status);
      console.log(body);
      this.objectTransitService.updateBulkObjectTransitUponApproval(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          this.getObjectsTransitByObjectTransitId(this.singleObjectsTransitData?.transitId, 'bulk');
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    }
  }

  rejectTransit(type: 'single' | 'bulk') {
    if (type === 'single') {
      let receivedDetails = {
        "version": 0, "isActive": true, "description": "",
        "userId": this.userCred.userId, "userName": this.userCred.userName,
        "userMobileNo": this.userCred.userMobileNo, "userEmail": this.userCred.userEmail, "cid": this.cid
      };

      let body: any = {
        "version": this.singleObjectsTransitData?.version || 0,
        "isActive": true,
        "description": this.singleObjectsTransitData?.description || "",
        "id": this.singleObjectsTransitData?.id,
        "transitId": this.singleObjectsTransitData?.transitId,
        "objectInfoId": this.singleObjectsTransitData?.objectInfoId,
        "objectName": this.singleObjectsTransitData?.objectName,
        "requestDetails": this.singleObjectsTransitData?.requestDetails,
        "receivedDetails": receivedDetails,
        "status": "Reject",
        "fromCountry": this.singleObjectsTransitData?.fromCountry,
        "fromProvinceOrState": this.singleObjectsTransitData?.fromProvinceOrState,
        "fromDistrict": this.singleObjectsTransitData?.fromDistrict,
        "fromZone": this.singleObjectsTransitData?.fromZone,
        "fromPostalCode": this.singleObjectsTransitData?.fromPostalCode,
        "fromCity": this.singleObjectsTransitData?.fromCity,
        "fromLocation": this.singleObjectsTransitData?.fromLocation,
        "fromLat": this.singleObjectsTransitData?.fromLat || 0,
        "fromLng": this.singleObjectsTransitData?.fromLng || 0,
        "fromArea": this.singleObjectsTransitData?.fromArea || [{ "lat": "", "lng": "" }],
        "toCountry": this.singleObjectsTransitData?.toCountry,
        "toLat": this.singleObjectsTransitData?.toLat || 0,
        "toLng": this.singleObjectsTransitData?.toLng || 0,
        "toArea": this.singleObjectsTransitData?.toArea || [{ "lat": "", "lng": "" }],
        "toProvinceOrState": this.singleObjectsTransitData?.toProvinceOrState,
        "toDistrict": this.singleObjectsTransitData?.toDistrict,
        "toZone": this.singleObjectsTransitData?.toZone,
        "toPostalCode": this.singleObjectsTransitData?.toPostalCode,
        "toCity": this.singleObjectsTransitData?.toCity,
        "toLocation": this.singleObjectsTransitData?.toLocation,
        "objectTransitList": [],
        "cid": this.cid
      };

      this.objectTransitService.updateObjectTransitUponApproval(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.closePopUp();
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          this.getObjectsTransitByObjectTransitId(this.singleObjectsTransitData?.transitId, 'single');
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    } else {
      let receivedDetails = {
        "version": 0, "isActive": true, "description": "",
        "userId": this.userCred.userId, "userName": this.userCred.userName,
        "userMobileNo": this.userCred.userMobileNo, "userEmail": this.userCred.userEmail, "cid": this.cid
      };

      let bulkTransits = [];
      if (this.singleObjectsTransitData?.objectTransitList && this.singleObjectsTransitData.objectTransitList.length > 0) {
        bulkTransits = this.singleObjectsTransitData.objectTransitList.map((item: any) => ({
          ...item, status: "Reject"
        }));
      } else {
        bulkTransits = [{ ...(this.singleObjectsTransitData || {}), status: "Reject" }];
      }

      let body: any = this.getBulkUpdateBody(bulkTransits, "Reject", receivedDetails);
      body.description = this.singleObjectsTransitData?.description || "";
      body.objectTransit.description = this.singleObjectsTransitData?.description || "";

      this.objectTransitService.updateBulkObjectTransitUponApproval(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.closePopUp();
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          this.getObjectsTransitByObjectTransitId(this.singleObjectsTransitData?.transitId, 'bulk');
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    }
  }

  receiveTransit(type: 'single' | 'bulk') {
    if (type === 'single') {
      let body: any = {
        "version": 0, "isActive": true, "description": this.singleObjectsTransitData?.description,
        "id": this.singleObjectsTransitData?.id, "transitId": this.singleObjectsTransitData?.transitId,
        "objectInfoId": this.singleObjectsTransitData?.objectInfoId, "objectName": this.singleObjectsTransitData?.objectName,
        "requestDetails": this.singleObjectsTransitData?.requestDetails,
        "receivedDetails": {
          "version": 0, "isActive": true, "description": "",
          "userId": this.userCred?.userId, "userName": this.userCred?.userName,
          "userMobileNo": this.userCred?.userMobileNo, "userEmail": this.userCred?.userEmail, "cid": this.cid
        },
        "status": "Transferred", "fromCountry": this.singleObjectsTransitData?.fromCountry,
        "fromProvinceOrState": this.singleObjectsTransitData?.fromProvinceOrState, "fromDistrict": this.singleObjectsTransitData?.fromDistrict,
        "fromZone": this.singleObjectsTransitData?.fromZone, "fromPostalCode": this.singleObjectsTransitData?.fromPostalCode,
        "fromCity": this.singleObjectsTransitData?.fromCity, "fromLocation": this.singleObjectsTransitData?.fromLocation,
        "fromArea": this.singleObjectsTransitData?.fromArea, "toCountry": this.singleObjectsTransitData?.toCountry,
        "toArea": this.singleObjectsTransitData?.toArea, "toProvinceOrState": this.singleObjectsTransitData?.toProvinceOrState,
        "toDistrict": this.singleObjectsTransitData?.toDistrict, "toZone": this.singleObjectsTransitData?.toZone,
        "toPostalCode": this.singleObjectsTransitData?.toPostalCode, "toCity": this.singleObjectsTransitData?.toCity,
        "toLocation": this.singleObjectsTransitData?.toLocation, "cid": this.singleObjectsTransitData?.cid
      };
      this.objectTransitService.updateObjectTransit(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.closePopUp();
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          this.getObjectsTransitByObjectTransitId(this.singleObjectsTransitData?.transitId, 'single');
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    } else {

      let body: any = {
        "version": 0,
        "isActive": true,
        "description": "",
        "userId": this.userCred?.userId,
        "userName": this.userCred?.userName,
        "userMobileNo": this.userCred?.userMobileNo,
        "userEmail": this.userCred?.userEmail,
        "cid": this.cid
      }
      this.objectTransitService.updateBulkObjectTransitForTransfer(this.singleObjectsTransitData?.transitId, body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.closePopUp();
          this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
          this.getObjectsTransitByObjectTransitId(this.singleObjectsTransitData?.transitId, 'bulk');
        },
        (error: any) => {
          this.handleError(error);
        }
      );
    }
  }

  toggleAllAssets(event: any) {
    const checked = event.target.checked;
    if (this.singleObjectsTransitData?.objectTransitList) {
      this.singleObjectsTransitData.objectTransitList.forEach((item: any) => {
        item.selected = checked;
      });
    }
  }

  toggleSelection(item: any, event: any) {
    item.selected = event.target.checked;
  }

  mapToTransitItem(item: any, overrideStatus?: string) {
    let parent = this.singleObjectsTransitData || {};
    return {
      "version": item.version || 0,
      "isActive": item.isActive !== undefined ? item.isActive : true,
      "description": item.description || "",
      "id": item.id || "",
      "transitId": item.transitId || parent.transitId || 0,
      "objectInfoId": item.objectInfoId || 0,
      "objectName": item.objectName || "",
      "requestDetails": item.requestDetails || parent.requestDetails || {
        "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": this.cid
      },
      "receivedDetails": item.receivedDetails || parent.receivedDetails || {
        "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": this.cid
      },
      "status": "Reject",
      "fromCountry": item.fromCountry || parent.fromCountry || "",
      "fromProvinceOrState": item.fromProvinceOrState || parent.fromProvinceOrState || "",
      "fromDistrict": item.fromDistrict || parent.fromDistrict || "",
      "fromZone": item.fromZone || parent.fromZone || "",
      "fromPostalCode": item.fromPostalCode || parent.fromPostalCode || "",
      "fromCity": item.fromCity || parent.fromCity || "",
      "fromLocation": item.fromLocation || parent.fromLocation || "",
      "fromLat": item.fromLat || parent.fromLat || 0,
      "fromLng": item.fromLng || parent.fromLng || 0,
      "fromArea": item.fromArea || parent.fromArea || [{ "lat": "", "lng": "" }],
      "toCountry": item.toCountry || parent.toCountry || "",
      "toLat": item.toLat || parent.toLat || 0,
      "toLng": item.toLng || parent.toLng || 0,
      "toArea": item.toArea || parent.toArea || [{ "lat": "", "lng": "" }],
      "toProvinceOrState": item.toProvinceOrState || parent.toProvinceOrState || "",
      "toDistrict": item.toDistrict || parent.toDistrict || "",
      "toZone": item.toZone || parent.toZone || "",
      "toPostalCode": item.toPostalCode || parent.toPostalCode || "",
      "toCity": item.toCity || parent.toCity || "",
      "toLocation": item.toLocation || parent.toLocation || "",
      "cid": item.cid || parent.cid || this.cid
    };
  }

  getBulkUpdateBody(finalTransits: any[], status: string, customReceivedDetails?: any) {
    let receivedDetails = customReceivedDetails || this.singleObjectsTransitData?.receivedDetails || { "version": 0, "isActive": true, "description": "", "userId": 0, "userName": "", "userMobileNo": "", "userEmail": "", "cid": this.cid };

    let objectTransitPayload: any = this.mapToTransitItem(this.singleObjectsTransitData || {}, status);
    objectTransitPayload.receivedDetails = receivedDetails;
    objectTransitPayload.objectTransitList = finalTransits.map((item: any) => this.mapToTransitItem(item));

    return {
      "version": 0,
      "isActive": true,
      "description": this.singleObjectsTransitData?.description || "",
      "objectTransit": objectTransitPayload,
      "cid": this.cid
    };
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id;
    this.recordId = list.transitId;
    this.recordName = list.objectName;
  }

  deleteObjectTransit() {
    this.objectTransitService.hardDeleteObjectTransit(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllObjectsTransitWithPagination(this.pageNumber, this.recordsPerPage);
        document.getElementById("closeDeleteModalButton")?.click();
        this.closePopUp();
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  closePopUp() {
    this.recordId = "";
    this.recordName = "";
    this.addObjectsTransitForm.reset();
    this.addObjectsTransitForm.get('objectInfoIds')?.setValue([]);
    this.editObjectsTransitForm.reset();
    this.editBulkTransitForm.reset();
    this.editTransitArray.clear();
  }

  handleError(error: any) {
    this.formSubmit = false;
    if (error.error && error.error.errors && error.error.errors.length > 0) {
      this.toastr.error(error.error.errors[0].description);
    } else {
      this.toastr.error("An error occurred");
    }
  }

  getAllByLocationAndNotinTransitAndCid(location: string) {
    let body = {
      "location": [
        location
      ]
    }
    this.objectTransitService.getAllByLocationAndNotinTransitAndCid(body).subscribe(
      (response: any) => {
        this.objectInfoList = response.response || [];
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }
}
